import React, { useEffect, useRef, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { useDispatch } from 'react-redux'
import styles from './styles'
import {
  Typography,
  TextField,
  Box,
  Button,
  Paper,
  Grid,
  CircularProgress,
} from '@material-ui/core'

import { track } from '@amplitude/analytics-browser'

import { userGetSelfAction } from 'src/reducers/user/action'
import {
  addCourseDocumentAction,
  getCourseDocumentByIdAction,
  deleteCourseDocumentAction,
  generateQuizWithCourseDocumentAction,
  generateInformationWithCourseDocumentAction,
  generateSuggestionWithCourseDocumentAction,
} from 'src/reducers/assignment/action'
import { getUserLimits } from 'src/api/limit'
import { getCourseDocumentByIdService } from 'src/api/assignment'
import { LimitTypeEnum } from 'src/model/limit'
import CardHeader from './card-header'
import AddDocument from './add-document'
import GenerateContent from './generate-content'
import { useHistory } from 'react-router-dom'
import { componentBoxHideAction } from 'src/reducers/component-box/action'
import { startConnection } from 'src/utils/signalR-connection/signalR-connection'
import {
  addCourseCreationMessageReceivedListener,
  removeMessageReceivedListener,
} from 'src/utils/signalR-connection/signalR-connection'
import { snackbarShowAction } from 'src/reducers/snackbar/action'
import SnackbarMessage from 'src/model/snackbar'
import { SnackbarType } from 'src/model/snackbar/type'
import { guid } from 'src/utils/guid'

// The server signals completion with a single Clients.All broadcast fired at
// the end of a background job. Nothing replays it, so if that job is delayed
// or the frame is missed the spinner would hang forever. Poll as a fallback
// and give up with an error rather than spinning indefinitely.
const DOCUMENT_POLL_INTERVAL_MS = 5000
const DOCUMENT_TIMEOUT_MS = 120000

const CreateQuizWithAi = props => {
  const { entity, type, classes } = props
  const dispatch = useDispatch()
  const [courseId, setCourseId] = useState(
    window.location.pathname.split('quiz/')[1],
  )
  const [limitLoading, setLimitLoading] = useState(false)
  const [cardText, setCardText] = useState('')
  const [activeStep, setActiveStep] = useState(0)
  const [documentUrl, setDocumentUrl] = useState([''])
  const [file, setFile] = useState(null)
  const [documentPdf, setDocumentPdf] = useState()
  const [count, setAiCount] = useState()
  const [selectedMenu, setSelectedMenu] = useState('Text')
  const [documentText, setDocumentText] = useState()
  const [roleType, setRoleType] = useState()
  const [currentCredit, setCurrentCredit] = useState()
  const [limit, setLimit] = useState()
  const [refreshesAt, setRefreshesAt] = useState()
  const [produceType, setProduceType] = useState('Quiz')
  const [questionType, setQuestionType] = useState('Multiple Choice')
  const [maxQuestions, setMaxQuestions] = useState(3)
  const [languageCode, setLanguageCode] = useState("auto")
  const [documentsUploaded, setDocumentsUploaded] = useState(false)
  const [courseDocuments, setCourseDocuments] = useState([])
  const [titleList, setTitleList] = useState()
  const [title, setTitle] = useState()
  const uploadWatchdogRef = useRef(null)
  let history = useHistory()

  useEffect(() => {
    if (produceType == 'Quiz') return
    let formDataSuggestion = new FormData()
    formDataSuggestion.append('collectionName', courseId)
    formDataSuggestion.append('number', '3')

    dispatch(
      generateSuggestionWithCourseDocumentAction(
        formDataSuggestion,
        response => {
          setTitleList(response.message)
        },
      ),
    )
  }, [produceType])

  useEffect(() => {
    //This useEffect hook is used for getting user's limit count for course creation.
    setLimitLoading(true)

    getUserLimits().then(response => {
      let count = response.data.find(
        x => x.limit.type == LimitTypeEnum.ContentInputLengthPerQuiz,
      ).count

      let limit = response.data.find(
        x => x.limit.type == LimitTypeEnum.ContentInputLengthPerQuiz,
      ).limit.upperLimit

      let refreshedAt = response.data.find(
        x => x.limit.type == LimitTypeEnum.ActiveQuizzes,
      ).refreshedAt

      setRoleType(response.data[0].limit.roleType)
      setRefreshesAt(refreshedAt)
      setLimit(limit)
      setAiCount(count)
      setCurrentCredit(limit - count)
      setLimitLoading(false)
    })
  }, [])

  useEffect(() => {
    if (entity && entity.cardDtos.length > 0) {
      let textArray = ''
      entity.cardDtos.map(
        entity =>
          entity.type == 1 && (textArray = textArray + ' ' + entity.text),
      )

      textArray = textArray.replaceAll('</h3>', '</h3><br>')
      textArray = textArray.replaceAll('</h2>', '</h2><br>')
      textArray = textArray.replaceAll('</h1>', '</h1><br>')
      textArray = textArray.replaceAll('</h4>', '</h4><br>')
      textArray = textArray.replaceAll('</p>', '</p><br>')
      //remove code brakes and tabs
      textArray = textArray.replace(/\n/g, '')
      textArray = textArray.replace(/\t/g, '')

      //keep html brakes and tabs
      textArray = textArray.replace(/<\/td>/g, '\t')
      textArray = textArray.replace(/<\/table>/g, '\n')
      textArray = textArray.replace(/<\/tr>/g, '\n')
      textArray = textArray.replace(/<\/p>/g, '\n')
      textArray = textArray.replace(/<\/div>/g, '\n')
      textArray = textArray.replace(/<\/h>/g, '\n')
      textArray = textArray.replace(/<br>/g, '\n')
      textArray = textArray.replace(/<br( )*\/>/g, '\n')
      textArray.replace(/(<([^>]+)>)/gi, '')
      setCardText(textArray)
    }
  }, [entity])

  useEffect(() => {
    dispatch(userGetSelfAction())
  }, [])

  useEffect(() => {
    getCourseDocuments()
  }, [])

  const getCourseDocuments = () => {
    dispatch(
      getCourseDocumentByIdAction(courseId, response => {
        if (response == null) return
        let documents = [...response]
        setCourseDocuments(documents)
        documents.length == 0
          ? setDocumentsUploaded(false)
          : setDocumentsUploaded(true)
      }),
    )
  }

  const clearUploadWatchdog = () => {
    const watchdog = uploadWatchdogRef.current
    if (!watchdog) return

    clearInterval(watchdog.pollId)
    clearTimeout(watchdog.timeoutId)
    removeMessageReceivedListener(watchdog.listener)
    uploadWatchdogRef.current = null
  }

  useEffect(() => clearUploadWatchdog, [])

  /**
   * Waits for the uploaded document to become available, via the socket
   * broadcast when it arrives and by polling when it does not.
   */
  const watchForDocument = () => {
    clearUploadWatchdog()

    const targetId = type == 'end' ? entity.id.toString() : courseId

    const finish = () => {
      // The socket frame and a poll response can land together; only the
      // first one through should refresh the list.
      if (!uploadWatchdogRef.current) return

      clearUploadWatchdog()
      setLimitLoading(false)
      getCourseDocuments()
    }

    const listener = message => {
      if (message[0] == targetId) finish()
    }

    addCourseCreationMessageReceivedListener(listener)

    // Called directly rather than through the saga: the shared saga wrapper
    // toggles the global preloader, which would flash on every poll.
    const pollId = setInterval(() => {
      getCourseDocumentByIdService(courseId)
        .then(response => {
          if (response.data && response.data.length > 0) finish()
        })
        .catch(() => {
          // A failed poll is not fatal, the timeout below is the backstop.
        })
    }, DOCUMENT_POLL_INTERVAL_MS)

    const timeoutId = setTimeout(() => {
      clearUploadWatchdog()
      setLimitLoading(false)

      const message = new SnackbarMessage(guid().uid(), SnackbarType.ERROR, [
        'message.error.documentProcessingTimeout',
      ])
      dispatch(snackbarShowAction(message))
    }, DOCUMENT_TIMEOUT_MS)

    uploadWatchdogRef.current = { listener, pollId, timeoutId }
  }

  const handleUploadDocuments = async () => {
    setLimitLoading(true)
    let formData = new FormData()
    formData.append('courseId', courseId)
    switch (selectedMenu) {
      case 'Text':
        formData.append('text', documentText ? documentText : null)
        track('ai-wiz-add-text')
        break
      case 'Upload':
        formData.append('file', file)
        track('ai-wiz-add-pdf')

        break
      case 'Url':
        formData.append('urls', documentUrl ? documentUrl : null)
        track('ai-wiz-add-url')
        break
      default:
    }
    // Attach the listener and connect BEFORE the request goes out: the
    // broadcast is fire-and-forget, so a listener attached only after the
    // response returns can miss it entirely.
    watchForDocument()
    await startConnection()

    dispatch(addCourseDocumentAction(formData, () => {}))
  }
  const handleGenerate = () => {
    switch (produceType) {
      case 'Quiz':
        let formDataQuiz = new FormData()
        formDataQuiz.append('collectionName', courseId)
        formDataQuiz.append('number', maxQuestions)
        formDataQuiz.append('languageCode', languageCode)
        formDataQuiz.append(
          'quizType',
          (questionType == 'Multiple Choice' && 'single choice') ||
            (questionType == 'True/False' && 'True or False') ||
            (questionType == 'Free Text' && 'short answer') ||
            (questionType == 'Fill in the Blank' && 'fill in the blanks'),
        )

        formDataQuiz.append('goal', 'quiz')

        dispatch(
          generateQuizWithCourseDocumentAction(formDataQuiz, () => {
            track('ai-ai-wiz-generate-click', {
              type: produceType,
              questionType: questionType,
            })
            const element = document.getElementById(
              'question-' + entity.cardDtos.length,
            )
            if (element) {
              // 👇 Will scroll smoothly to the top of the next section
              setTimeout(element.scrollIntoView({ behavior: 'smooth' }), 2000)
            }
            if (type == 'end') {
              dispatch(componentBoxHideAction())
            } else {
              history.push('/quiz/' + courseId)
            }
          }),
        )
        break
      case 'Information':
        let formDataInfo = new FormData()
        formDataInfo.append('collectionName', courseId)
        formDataInfo.append('goal', 'info')
        formDataInfo.append('title', title)
        dispatch(
          generateInformationWithCourseDocumentAction(formDataInfo, () => {
            if (type == 'end') {
              dispatch(componentBoxHideAction())
            } else {
              history.push('/quiz/' + courseId)
            }
          }),
        )
        break
      default:
        break
    }
  }
  const handleDelete = (source, id) => {
    let formDataDelete = new FormData()
    formDataDelete.append('collectionName', courseId)
    formDataDelete.append('source', source)
    formDataDelete.append('documentId', id)

    dispatch(
      deleteCourseDocumentAction(formDataDelete, response => {
        setCourseDocuments(
          courseDocuments.filter(item => item.fileName != response.fileName),
        )
        let req =
          courseDocuments.filter(item => item.fileName != response.fileName)
            .length == 0

        if (req == true) {
          setDocumentsUploaded(false)
          setDocumentText('')
          setDocumentUrl([''])
          setFile(null)
          setCardText('')
          setSelectedMenu('Text')
        }
      }),
    )
  }
  const onHandleBack = () => {
    setDocumentsUploaded(true)
  }
  return (
    <Grid container className={classes.page}>
      <Grid item className={classes.stepperGrid}>
        <Paper className={classes.stepperHolder}>
          {limitLoading ? (
            <div className={classes.loaderHolder}>
              <CircularProgress size={16} />
            </div>
          ) : (
            <>
              <CardHeader entity={entity} dispatch={dispatch} />
              {documentsUploaded ? (
                <GenerateContent
                  documentsUploaded={documentsUploaded}
                  setDocumentsUploaded={setDocumentsUploaded}
                  selectedMenu={selectedMenu}
                  setSelectedMenu={setSelectedMenu}
                  courseDocuments={courseDocuments}
                  produceType={produceType}
                  setProduceType={setProduceType}
                  questionType={questionType}
                  setQuestionType={setQuestionType}
                  maxQuestions={maxQuestions}
                  setMaxQuestions={setMaxQuestions}
                  languageCode={languageCode}
                  setLanguageCode={setLanguageCode}
                  handleGenerate={handleGenerate}
                  handleDelete={handleDelete}
                  titleList={titleList}
                  setTitleList={setTitleList}
                  setTitle={setTitle}
                  title={title}
                  setDocumentUrl={setDocumentUrl}
                  setDocumentText={setDocumentText}
                  setFile={setFile}
                  roleType={roleType}
                />
              ) : (
                <AddDocument
                  documentUrl={documentUrl}
                  setDocumentUrl={setDocumentUrl}
                  file={file}
                  setFile={setFile}
                  documentPdf={documentPdf}
                  setDocumentPdf={setDocumentPdf}
                  selectedMenu={selectedMenu}
                  setSelectedMenu={setSelectedMenu}
                  documentText={documentText}
                  setDocumentText={setDocumentText}
                  roleType={roleType}
                  handleUploadDocuments={handleUploadDocuments}
                  cardText={cardText}
                  dispatch={dispatch}
                  limit={limit}
                />
              )}
            </>
          )}
        </Paper>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(CreateQuizWithAi)
